import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'comment-form-modal',
  templateUrl: './comment-form-modal.component.html',
  styleUrls: ['./comment-form-modal.component.scss'],
  animations: [
    slide
  ]
})
export class CommentFormModalComponent implements OnInit {
  @Input()  selectedComment: any;
  @Input()  post: any;
  @Input()  forum: any;

  @Output() onHideFormModal = new EventEmitter<boolean>();

  comment = {
    content: ""
  };

  constructor(private dbService: DBService) { }

  ngOnInit() {
    if (this.selectedComment) {
      this.comment.content = this.selectedComment.content;
    }
  }

  onHideModal() {
    this.onHideFormModal.emit(true);
  }

  submitForm() {
    if (this.selectedComment) {
      this.dbService.updateComment(this.post.$key,
                                   this.selectedComment.$key,
                                   this.comment);
    } else {
      this.dbService.addComment(this.forum.$key, this.post.$key, this.comment);
    }

    this.onHideModal();
  }

}



// WEBPACK FOOTER //
// ./src/app/forums/comment-form-modal/comment-form-modal.component.ts